import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "addUser",
    serviceName: "unitadmin",
    query: gql`
      mutation addUser(
        $lastname: String
        $firstname: String
        $cellphone: String!
        #$skin_color: String
        $birth_date: String
        $national_code: String
        $insurance_type: String
        $financial_situation: String
        $need_activation: Int
        $type_id: String
        $gender: Int
      ) {
        addUser(
          lastname: $lastname
          firstname: $firstname
          cellphone: $cellphone
          #skin_color: $skin_color
          birth_date: $birth_date
          national_code: $national_code
          insurance_type: $insurance_type
          financial_situation: $financial_situation
          need_activation: $need_activation
          type_id: $type_id
          gender: $gender
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
